import React, { useEffect } from 'react';
import { Circles } from 'react-loader-spinner';

import './Loader.css';

export const Loader = () => {
  useEffect(() => {}, []);

  return (
    <div className='loader-container'>
      <Circles height='80' width='80' color='#ababab' ariaLabel='circles-loading' visible={true} />
    </div>
  );
};
